import React, { } from 'react';
import { InlineWidget } from 'react-calendly';
import './CSS/BookMeeting.css';


const BookMeeting = () => {
    return (
        <div className="book-meeting-page">
            <div className="book-meeting-container">
                <h2>Book A Meeting</h2>
                <div className="calendly-container">
                    <InlineWidget url="https://calendly.com/joel-pinel" />
                </div>
            </div>
        </div>
    );
};

export default BookMeeting;
